const BASE_PATH = '';
const ACCESS_TOKEN_KEY = 'pid';
export default {
  BASE_PATH,
  ACCESS_TOKEN_KEY,
};
